export const getBrandPart = (brandName: string | null | undefined) => {
  return brandName ? `${brandName}の` : ''
}

export const getCategoryPart = (
  categoryName?: string,
  childCategoryName?: string
) => {
  if (childCategoryName) return childCategoryName
  if (categoryName) return categoryName
  return ''
}

export const getMemberName = (member: {
  nick_name: string
  shop?: { name: string } | null
}) => {
  return `${member.nick_name}${member.shop ? `(${member.shop.name})` : ''}`
}
